import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";
import { StatusEnum } from "types/core";

export const GET_ALL_QUERY = print(gql`
  query Events($page: Int, $perPage: Int, $search: String, $status: StatusEnum) {
    Events(page: $page, perPage: $perPage, search: $search, status: $status) {
      items {
        id
        slug
        status
        publishOn
        title
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  id: number;
  slug: string;
  status: StatusEnum;
  publishOn?: string;
  title: string;
}

export interface GetAllGql {
  Events: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}

export interface GetAllVariables {
  page?: number;
  perPage?: number;
  search?: string | null;
  status?: StatusEnum | null;
}
